// extracted by mini-css-extract-plugin
module.exports = {"container":"_2ryMbKK4Go93zQzEEJ5oC_","label":"_2xyDbghvPZgnoxpY9Kv-x7","info":"iRTJ7LdYw0qPFr8BSeS77"};